import { Link } from "react-router-dom";
import { ArrowRight, FileText, PhoneCall } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { useSite } from "../../context/SiteContext";
import { trackClick } from "../../lib/analytics";

const ServiceLines = () => {
  const { scrollToId } = useSite();
  return (
    <section id="services" className="bg-white dark:bg-brand-ink py-24 md:py-32" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeading
          id="services"
          overline="Our Services"
          title={<>Specialized remote support <span className="text-brand-gradient">for healthcare practices</span></>}
          sub="Two dedicated service lines — built around accuracy, patient experience and your existing workflows."
        />
        <div className="mt-14 grid lg:grid-cols-2 gap-6">
          <Reveal>
            <div className="group h-full rounded-[2rem] bg-slate-50 dark:bg-white/5 border border-slate-100 dark:border-white/10 p-9 md:p-12 flex flex-col hover:shadow-[0_30px_70px_-35px_rgba(42,49,146,0.35)] hover:-translate-y-1 transition-[transform,box-shadow] duration-300" data-testid="service-card-medical">
              <div className="w-14 h-14 rounded-2xl bg-brand-navy dark:bg-brand-sky flex items-center justify-center">
                <FileText size={24} className="text-white dark:text-brand-ink" />
              </div>
              <p className="mt-7 text-xs font-bold uppercase tracking-[0.25em] text-brand-sky">For Medical Practices</p>
              <h3 className="mt-3 font-display text-2xl md:text-3xl font-semibold tracking-tight text-slate-900 dark:text-white">Virtual Medical Scribing</h3>
              <p className="mt-4 flex-1 text-base leading-relaxed text-slate-600 dark:text-slate-300">
                Real-time documentation support that helps clinicians spend less time charting and more time with patients.
              </p>
              <button
                data-testid="explore-medical-scribing-button"
                onClick={() => { trackClick("explore_medical_scribing"); scrollToId("how-it-works"); }}
                className="mt-8 inline-flex items-center gap-2 self-start rounded-full bg-brand-navy dark:bg-brand-sky text-white dark:text-brand-ink font-bold px-7 py-3.5 text-sm hover:shadow-[0_16px_40px_-14px_rgba(42,49,146,0.55)] transition-shadow duration-300"
              >
                Explore Medical Scribing <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform duration-300" />
              </button>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="group relative h-full overflow-hidden rounded-[2rem] bg-gradient-to-br from-brand-navy to-brand-navy-deep p-9 md:p-12 flex flex-col hover:shadow-[0_40px_90px_-40px_rgba(42,49,146,0.7)] hover:-translate-y-1 transition-[transform,box-shadow] duration-300" data-testid="service-card-dental">
              <div className="absolute -right-16 -top-16 w-64 h-64 rounded-full bg-brand-sky/20 blur-3xl" />
              <div className="relative w-14 h-14 rounded-2xl bg-white/10 border border-white/15 flex items-center justify-center">
                <PhoneCall size={24} className="text-brand-sky" />
              </div>
              <p className="relative mt-7 text-xs font-bold uppercase tracking-[0.25em] text-brand-sky">For Dental Practices</p>
              <h3 className="relative mt-3 font-display text-2xl md:text-3xl font-semibold tracking-tight text-white">Dental Virtual Front Desk</h3>
              <p className="relative mt-4 flex-1 text-base leading-relaxed text-white/70">
                24/7 call support and trained Dental Virtual Assistants who work alongside dental practices to help manage
                calls, scheduling, insurance verification and patient follow-ups.
              </p>
              <Link
                to="/dental"
                onClick={() => trackClick("explore_dental_front_desk")}
                data-testid="explore-dental-button"
                className="relative mt-8 inline-flex items-center gap-2 self-start rounded-full bg-white text-brand-navy font-bold px-7 py-3.5 text-sm hover:shadow-[0_16px_40px_-14px_rgba(255,255,255,0.4)] transition-shadow duration-300"
              >
                Explore Dental Front Desk <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform duration-300" />
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
export default ServiceLines;
